module.exports = __webpack_public_path__ + "media/images/admin/qrcode-10d871dd42472447113bb1137c51d1f2.svg";